import SecureWallet from "@/assetsV3/Wallet/List/SecureWallet";
import SniperWallet from "@/assetsV3/Wallet/List/SniperWallet";
import { ChainIdEnum, RPC_URLS } from "@/types/enums/WalletTypeEnum";
import SolanaIcon from "@/assetsV3/Wallet/SolanaIcon";
import { ReactElement, SVGProps } from "react";
import BscBalanceIcon from "@/assetsV3/Wallet/Deposit/BscBalance";
import BaseIcon from "@/assetsV3/Wallet/Deposit/BaseIcon";
import SonicWallet from "@/assetsV3/Wallet/Deposit/SonicWallet";
import { ethers } from "ethers";
import { Connection, PublicKey } from "@solana/web3.js";
import axios from "axios";
import SolanaChainIcon from "@/assetsV3/Wallet/Chains/SolanaChainIcon";
import BscChainIcon from "@/assetsV3/Wallet/Chains/BscChainIcon";
import BaseChainIcon from "@/assetsV3/Wallet/Chains/BaseChainIcon";
import EthChainIcon from "@/assetsV3/Wallet/Chains/EthChainIcon";
import EthWallet from "@/assetsV3/Wallet/Deposit/EthWallet";

const iconMap: Record<
  string,
  (props: React.SVGProps<SVGSVGElement>) => JSX.Element
> = {
  sniper_wallet: SniperWallet,
  secure_wallet: SecureWallet,
};

export function WalletIcon({ iconName }: { iconName: string }) {
  const IconComponent = iconMap[iconName];
  return IconComponent ? <IconComponent /> : null; // Render SVG or nothing
}

export const CHAIN_TOKENS_LOGO: Record<
  ChainIdEnum,
  (props: SVGProps<SVGSVGElement>) => React.ReactElement
> = {
  [ChainIdEnum.bsc]: BscBalanceIcon,
  [ChainIdEnum.base]: BaseIcon,
  [ChainIdEnum.sonic]: SonicWallet,
  [ChainIdEnum.solana]: SolanaIcon,
  [ChainIdEnum.ethereum]: EthWallet,
};

export const EXCLUDED_ADDRESSES = [
  "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE",
  "So11111111111111111111111111111111111111112",
  "So11111111111111111111111111111111111111111",
  "0x4200000000000000000000000000000000000006",
].map((addr) => addr.toLowerCase()); // Convert once to lowercase

export const ActivityChainFilter = [
  {
    id: 0,
    title: "Solana",
    value: "solana",
    icon: SolanaChainIcon,
  },
  {
    id: 1,
    title: "Base",
    value: "base",
    icon: BaseChainIcon,
  },
  // {
  //   id: 2,
  //   title: "BSC (BEP20)",
  //   value: "bsc",
  //   icon: BscChainIcon,
  // },
  // {
  //   id: 3,
  //   title: "Sonic",
  //   value: "sonic",
  //   icon: SonicWallet,
  // },
  // {
  //   id: 4,
  //   title: "Ethereum",
  //   value: "evm",
  //   icon: EthChainIcon,
  // },
];